export function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('REGIME_TVA_ALREADY_EXIST_IN_SOCIETY') === 0) {
        messages.push({
          message: 'editionRegimeTva.error.regimeAlreadyExiste',
        });
      }
      if (message.indexOf('Regime_Tva_Already_Exist_For_Society_But_not_Active') === 0) {
        messages.push({
          message: 'editionRegimeTva.error.regimeAlreadyExisteInactif',
        });
      }
    }
  });
}

export function validationArchivage(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('REGIME_TVA_CANNOT_ARCHIVE_ALREADY_DEFAULT') === 0) {
        messages.push({
          message: 'listeRegimeTva.archivage.error.alreadyInAgency',
        });
      }
    }
  });
}
